import { render, staticRenderFns } from "./TaskOverview.vue?vue&type=template&id=233144d0&scoped=true&"
import script from "./TaskOverview.vue?vue&type=script&lang=js&"
export * from "./TaskOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233144d0",
  null
  
)

export default component.exports